import * as React from 'react'
import { useHistory } from 'react-router-dom'
import styled from 'styled-components'
import Label from './Label'
import { News, PublicLocale } from '../../../../types'
import MobilityHelper from '../../../../helpers/MobilityHelper'
import { AppState } from '../../../store'
import { useSelector } from 'react-redux'
import { newsLink } from '../../../helpers/NavigationHelper'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  border-radius: 10px;
  cursor: pointer;
  box-shadow: rgba(0, 0, 0, 0.08) 0px 0px 0px 1px, rgba(0, 0, 0, 0.06) 0px 2px 8px;
  transition: box-shadow 150ms;
  background-color: rgb(255, 255, 255);
  cursor: pointer;
`

const Cover = styled.div`
  display: flex;
  flex-direction: column;

  img {
    width: 100%;
    height: auto;
    object-fit: cover;
    overflow: hidden;
    border-radius: 10px 10px 0px 0px;
  }
`

const Section = styled.div`
  flex: 1 1 0%;
  display: flex;
  flex-direction: column;
  padding: 16px 20px;
`

const Labels = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding-bottom: 12px;
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

const Title = styled.div`
  font-weight: 600;
  font-size: 14px;
  line-height: 21px;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  margin-bottom: 4px;
`

const Description = styled.div`
  width: 100%;
  overflow: hidden;
  font-size: 14px;
  line-height: 21px;
  color: rgb(108, 111, 116);
`

interface IProps {
  news: News
  locale: PublicLocale
}

const NewsItem = (props: IProps) => {
  const { news, locale } = props
  const history = useHistory()

  const title = MobilityHelper.getTranslation(locale, news.translations, 'title')
  const description = MobilityHelper.getTranslation(locale, news.translations, 'summary')

  const onClick = () => {
    history.push(newsLink(news))
  }

  return (
    <Container onClick={onClick}>
      {news.cover_image_url && <Cover>
        <img src={news.cover_image_url} />
      </Cover>}

      <Section>
        {news.tags?.length > 0 && <Labels>
          {news.tags.map((tag) => (
            <Label key={tag.id}>{tag.name}</Label>
          ))}
        </Labels>}

        <Content>
          <Title>{title}</Title>
          <Description>{description}</Description>
        </Content>
      </Section>
    </Container>
  )
}

export default NewsItem